import axios from "axios";

const apiKey = process.env.REACT_APP_X_API_KEY;
const appKey = process.env.REACT_APP_APP_KEY;
const appBaseUrl = process.env.REACT_APP_API_ADMIN_BASE_URL;

// Helper function to get authentication headers based on user type
const getAuthHeaders = () => {
    const token = localStorage.getItem("token");
    const userType = localStorage.getItem("userType");
    const currentPartnerId = localStorage.getItem("pid");

    
    // If user has a Bearer token, use it
    if (token) {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json"
        };
        
        // Also include partner ID if available
        if (currentPartnerId) {
            headers["X-Partner-ID"] = currentPartnerId;
        }
        
        return headers;
    }
    
    // If user is a partner and has app key, use partner authentication
    if (userType === "partner" && appKey && currentPartnerId) {
        return {
            "APP-KEY": appKey,
            "X-Partner-ID": currentPartnerId,
            "Content-Type": "application/json"
        };
    }
    
    // Fallback to X-API-KEY for legacy support
    return {
        "X-API-KEY": apiKey,
        "Content-Type": "application/json"
    };
};

export const getFailedTransactions = async (partnerId, page = 1, perPage = 20, startDate = null, endDate = null) => {
  if (!appBaseUrl || !partnerId) {
    return { success: false, message: "Missing configuration or partner ID. Please try again later." };
  }

  try {
    const params = new URLSearchParams({
      partner_id: partnerId,
      page: page.toString(),
      per_page: perPage.toString()
    });

    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);

    const response = await axios.get(
      `${appBaseUrl}/transactions/failed?${params}`,
      {
        headers: getAuthHeaders(),
        withCredentials: true,
      }
    );

    if (response.data.status) {
      return {
        success: true,
        failedTransactions: response.data.data || [],
        pagination: response.data.pagination || {},
        filters: response.data.filters || {},
        message: response.data.message || "Failed transactions retrieved successfully"
      };
    } else {
      return {
        success: false,
        message: response.data.message || "Failed to retrieve failed transactions"
      };
    }
  } catch (error) {
    const errorData = error.response?.data;
    return {
      success: false,
      message: errorData?.message || "Failed to retrieve failed transactions. Please try again."
    };
  }
};
